import { RootState } from '@store/store'
import { prop } from 'ramda'
import { createSelector } from 'reselect'

import {
  ASSESSMENT_EC,
  ASSESSMENT_EC_ALL,
  ASSESSMENT_EC_CREATE,
  ASSESSMENT_EC_OUTCOME_REPORT,
  ASSESSMENT_EC_PAPER,
  ASSESSMENT_EC_REPORT,
  ASSESSMENT_EC_STATUS,
  ASSESSMENT_EC_UPDATE,
  GLOBAL_STATE,
} from '../constants/actionTypes'

const assessmentsECSelector = (state: RootState) => prop(GLOBAL_STATE, state)

export const assessmentECUpdateSelector = createSelector(assessmentsECSelector, data => data[ASSESSMENT_EC_UPDATE])

export const assessmentECCreateSelector = createSelector(assessmentsECSelector, data => data[ASSESSMENT_EC_CREATE])

export const assessmentECAllSelector = createSelector(assessmentsECSelector, data => data[ASSESSMENT_EC_ALL])

export const assessmentECListSelector = createSelector(assessmentsECSelector, data => data[ASSESSMENT_EC])

export const assessmentECPaperSelector = createSelector(assessmentsECSelector, data => data[ASSESSMENT_EC_PAPER])

export const assessmentECStatusSelector = createSelector(assessmentsECSelector, data => data[ASSESSMENT_EC_STATUS])

export const assessmentECOutcomeReportSelector = createSelector(
  assessmentsECSelector,
  data => data[ASSESSMENT_EC_OUTCOME_REPORT]
)

export const assessmentECReportSelector = createSelector(assessmentsECSelector, data => data[ASSESSMENT_EC_REPORT])
